import { render, staticRenderFns } from "./init.vue?vue&type=template&id=762a9fc6"
import script from "./init.vue?vue&type=script&lang=js"
export * from "./init.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports